<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid md:grid-cols-3 gap-4">
                            <el-form-item class="no-margin" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="部門名">
                                <el-input v-model="searchForm.department_name" placeholder="部門名を入力" />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="部門名">
                                        <el-input v-model="searchForm.department_name" placeholder="部門名を入力" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info"
                        @click="handleAddButton" circle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info"
                        @click="handleAddButton">新規登録</el-button>
                    
                    <el-upload v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" class="" ref="upload" :on-change="handleImportButton" :auto-upload="false"
                        :show-file-list="false" accept=".csv">
                        <el-tooltip content="CSVインポート" placement="top">
                            <el-button class="custom-icon-btn mx-3" type="info" circle>
                                <span class="material-symbols-outlined">
                                    upload_2
                                </span>
                            </el-button>
                        </el-tooltip>
                    </el-upload>

                    <el-button class="custom-icon-btn" type="info" 
                        @click="handleExportButton" circle>
                        <el-tooltip content="CSVエクスポート" placement="top">
                            <span class="material-symbols-outlined">
                                download_2
                            </span>
                        </el-tooltip>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>部門マスタ（組織名　部門名）</span>
                    <div class="ml-auto">
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('name')"
                                :class="['mobile-sort-btn', sortField === 'name' ? 'active' : '']">
                                部門名    
                            </el-button>
                            <span>アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </div>
                </div>
                
                <div style="height: calc(100vh - 227px); overflow-y: auto;">
                    <el-card style="border: 1px solid #d1d5db; border-radius: 0px"
                        v-for="item in mTableData" :key="item.department_id">
                        <el-row align="middle">
                            <el-col :span="2">
                                <el-button
                                    class="w-8 h-16"
                                    type="info" 
                                    style="background-color: #b7b7b7;"
                                    text
                                    bg
                                    @click="handleEditButton(item)">
                                    <span>詳<br>細</span>
                                </el-button>
                            </el-col>

                            <el-col :span="18" class="ml-2">
                                <div>{{ item.organization_name }}</div>
                                <div>{{ item.name }}{{ item.is_head === '1' ? '（本部）' : '' }}</div>
                            </el-col>

                            <el-col :span="2" class="ml-2" align="right">
                                <span v-if="item.organization_id !== SYSTEM_ORGANIZATION" 
                                    class="material-symbols-outlined cursor-pointer"
                                    @click="handleDeleteButton(item)">
                                    delete
                                </span>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column label="部門マスタ" width="100" align="center">
                        <template #default="scope">
                            <el-button
                                class="w-12"
                                type="info"
                                style="background-color: #b7b7b7;"
                                text
                                bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="department_id" label="コード">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('department_id')">
                                <span>{{ getSortLabel('department_id') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'department_id' }">
                                        {{ getSortIcon('department_id') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="organization_name" label="所属組織名">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_name')">  
                                <span>{{ getSortLabel('organization_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                        {{ getSortIcon('organization_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="部門名">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('name')">
                                <span>{{ getSortLabel('name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'name' }">
                                        {{ getSortIcon('name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_head" label="本部">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('is_head')">
                                <span>{{ getSortLabel('is_head') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'is_head' }">
                                        {{ getSortIcon('is_head') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            <span>{{ scope.row.is_head === '1' ? '○' : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updated_date" label="更新日">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('updated_date')">
                                <span>{{ getSortLabel('updated_date') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'updated_date' }">
                                        {{ getSortIcon('updated_date') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="{ row }">
                            {{ moment(row.updated_date).format('YYYY-MM-DD HH:mm:ss') }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_by" label="作成者">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('created_by')">
                                <span>{{ getSortLabel('created_by') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'created_by' }">
                                        {{ getSortIcon('created_by') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="削除" width="52" align="center">
                        <template #default="scope">
                            <span v-if="scope.row.organization_id !== SYSTEM_ORGANIZATION" 
                                class="material-symbols-outlined cursor-pointer mt-2"
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handlePageChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                    @current-change="handlePageChange" />
                </div>
            </div>
        </el-mian>
    </el-container>
    
    <!-- 新規登録更新对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="dialogFormVisible"
        :title="form.add_update === 'add' ? '新規登録' : '詳細'" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
            <el-form-item label="コード" prop="department_id">
                <el-input v-model="form.department_id" autocomplete="off" :disabled="form.add_update === 'update'"
                    placeholder="コード" />
            </el-form-item>
            <el-form-item label="部門名" prop="name">
                <el-input v-model="form.name" autocomplete="off" placeholder="部門名" />
            </el-form-item>
            <el-form-item label="所属組織" prop="organization_id">
                <OrganizationSelect v-model="form.organization_id" placeholder="組織を選択" :disabled="form.add_update === 'update'" />
            </el-form-item>
            <el-form-item label="本部機関">
                <el-switch v-model="form.is_head" active-value="1" inactive-value="0" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    {{ form.add_update === 'add' ? '登録' : '更新' }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick } from 'vue';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import type { FormInstance, FormRules, UploadFile } from 'element-plus';
import { Delete, Edit, Search, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ImportResponseData, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import router from '@/router';
import moment from 'moment';
import { ALL, CSV_MAX_SIZE, ROLES, ROUTES, SYSTEM_ORGANIZATION } from '@/config/constants';
import { sortingUtil, SortConfig, SortableItem } from '@/components/common/SortingUtil';

interface DepartmentInfo {
    add_update?: Operation,
    department_id: string,
    name: string,
    organization_id?: string,
    organization_name?: string,
    is_head: string,
    created_by?: string,
    created_date?: string,
    updated_by?: string,
    updated_date?: string,
}

export default defineComponent({
    name: 'MngOrgnization',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        OrganizationSelect,
        Delete,
        Plus,
        Edit,
        Search,
    },
    setup() {
        const searchForm = ref<any>({
            organization_id: ALL,
            department_name: '',
        });

        const form = ref<DepartmentInfo>({
            add_update: Operation.unknow,
            department_id: '',
            name: '',
            organization_id: '',
            organization_name: '',
            is_head: '',
        });

        const drawer = ref(false);

        const loading = ref<boolean>(true);

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref<boolean>(false);

        const formRef = ref<FormInstance>()
        const rules = ref<FormRules>({
            organization_id: [
                { required: true, message: '所属組織を選択してください', trigger: 'blur' },
            ],
            department_id: [
                { required: true, message: 'コードを入力してください', trigger: 'blur' },
                { min: 1, max: 20, message: 'コードは1〜20文字の間で入力してください', trigger: 'blur' }
            ],
            name: [
                { required: true, message: '部門名を入力してください', trigger: 'blur' },
                { min: 2, max: 50, message: '部門名は2〜50文字の間で入力してください', trigger: 'blur' }
            ]
        })

        const sortConfig: SortConfig = {
            department_id: {
                label: 'コード',
                mobileLabel: 'コード',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            organization_name: {
                label: '所属組織名',
                mobileLabel: '所属組織名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            name: {
                label: '部門名',
                mobileLabel: '部門名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            is_head: {
                label: '本部',
                mobileLabel: '本部',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            updated_date: {
                label: '更新日',
                mobileLabel: '更新日',
                type: 'date' as const,
                defaultOrder: 'desc' as const
            },  
            created_by: {
                label: '作成者',
                mobileLabel: '作成者',
                type: 'string' as const,
                defaultOrder: 'desc' as const
            },
        };

        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';
        const allDepartments = ref<DepartmentInfo[]>([]);

        const {
            handleSort,
            getSortLabel,
            getSortIcon,
            paginatedData: mTableData,
            totalRecords: mTotalRecords,
            totalPages: mTotalPages,
            currentPage: mCurrentPage,
            pageSize: mPageSize,
            handleSizeChange,
            handlePageChange,
            showMoreDataAlert,
            sortField,
            sortOrder,
        } = sortingUtil(
            allDepartments,  
            sortConfig, 
        );

        /***** マウント **************************/
        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getDepartmentList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;
            getDepartmentList();
        };

        const handleAddButton = () => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    department_id: '',
                    name: '',
                    organization_id: '',
                    organization_name: '',
                    is_head: '',
                };
            });
        };

        const handleEditButton = (row: DepartmentInfo) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    department_id: row.department_id,
                    name: row.name,
                    organization_id: row.organization_id,
                    organization_name: row.organization_name,
                    is_head: row.is_head,
                };
            });
        };

        const handleDeleteButton = (row: DepartmentInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteDepartment(row);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleExportButton = () => {
            ElMessageBox.confirm('部門マスタをエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportDepartment();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addDepartment();
                    } else if (form.value.add_update === Operation.update) {
                        updateDepartment(form.value);
                    }
                    dialogFormVisible.value = false;
                }
            })
        }

        /***** DB 操作 **************************/
        const getDepartmentList = async () => {
            try {
                loading.value = true;
                const params: SearchRequest = {
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_name: searchForm.value.department_name,
                };

                const res: AxiosResponse<ResponseData<DepartmentInfo[]>> = await axios.get('/api/departments/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data, hasMoreData } = res.data;

                    allDepartments.value = data || [];
                    showMoreDataAlert(hasMoreData || false);
                } else {
                    ElMessage.error(getErrorMessage(PageType.DEPARTMENT, res.data.code));
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.DEPARTMENT));
            } finally {
                loading.value = false;
            }
        };

        const addDepartment = async () => {
            try {
                const res: AxiosResponse<ResponseData<DepartmentInfo>> = await axios.post('/api/departments', form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getDepartmentList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.ORGANIZATION, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.ORGANIZATION));
            }
        };

        const updateDepartment = async (row: DepartmentInfo) => {
            try {

                const res: AxiosResponse<ResponseData<DepartmentInfo>> = await axios.put(`/api/departments/${row.department_id}`, form.value);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getDepartmentList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.DEPARTMENT, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.DEPARTMENT));
            }
        };

        const deleteDepartment = async (row: DepartmentInfo) => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/departments/${row.department_id}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getDepartmentList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.DEPARTMENT, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.DEPARTMENT));
            }
        };

        const exportDepartment = async () => {
            try {
                const res: AxiosResponse<any> = await axios.post(`/api/departments/export`, {
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                    // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    const blob = new Blob([bom + res.data], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = '部門マスタ_' + moment(new Date().toISOString()).format('YYYYMMDDHHmmss') + '.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            }
            catch (error) {
                ElMessage.error('CSVエクスポート失敗しました。');
            }
        };

        const handleImportButton = (file: UploadFile) => {
            if (file.raw) {
                const formData = new FormData()
                formData.append('file', file.raw)

                //文件过大 100K
                if (file.raw.size > CSV_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return;
                }
                loading.value = true;
                axios.post('/api/departments/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res: AxiosResponse<ImportResponseData>) => {
                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        getDepartmentList();
                        ElMessage.success('CSVインポート成功');
                    } else {
                        ElMessage.error('CSVインポート失敗しました。');
                    }

                }).catch(error => {
                    ElMessage.error('CSVインポート失敗しました。');
                }).finally(() => {
                    loading.value = false;
                })
            } else {
                ElMessage.error('ファイルが無効です')
            }
        }

        return {
            searchForm,
            form,
            dialogFormVisible,
            loginUserRole,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            size,
            disabled,
            background,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDeleteButton,
            handleAddUpdateSubmit,
            handleExportButton,
            handleImportButton,
            formRef,
            rules,
            SYSTEM_ORGANIZATION,
            ROLES,
            drawer,
            moment,
            handleSort,
            getSortLabel,
            getSortIcon,
            sortField,
            sortOrder,
            handlePageChange,
            handleSizeChange,
            showMoreDataAlert,
            loginUserRoleIsHead,
        }
    }
});
</script>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>